var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLogo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 60,
    height: 60,
    fill: "#ECEEF0",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3766",
    "data-name": "Group 3766",
    transform: "translate(-1153 -19.626)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1",
    "data-name": "Mask Group 1",
    transform: "translate(1153 19.626)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(4.307 3.374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M0,3.824v6.853A76.784,76.784,0,0,1,15.821,6.392a64.861,64.861,0,0,1,17.014,0v9.854a58.823,58.823,0,0,0,6.847,2.588c3.9,1.2,8.74,2.231,8.74,2.231a59.015,59.015,0,0,0,1.029-9.537,29.442,29.442,0,0,0-1.029-7.7l-5.9-.767a26.733,26.733,0,0,1,.767,4.591,47.25,47.25,0,0,1,0,5.53l-5.136-1.65V.707A134.761,134.761,0,0,0,17.015.259,70.574,70.574,0,0,0,0,3.824Z",
    transform: "translate(0.366 0)",
    fill: "#ECEEF0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M29.162,0V6.239A89.474,89.474,0,0,0,15.59,6.91,25.2,25.2,0,0,0,6.8,9.833a32.922,32.922,0,0,0,5.7,12.18c4.629,6.327,12.625,12.473,12.625,12.473a61,61,0,0,0,8.078-5.92,37.817,37.817,0,0,0,5.677-6.553l4.4,3.484a85.882,85.882,0,0,1-8.244,8.988,97.477,97.477,0,0,1-9.914,7.887S13.942,34.927,7.66,25.894A49.979,49.979,0,0,1,0,6.239,61.529,61.529,0,0,1,13.585,1.431,80.671,80.671,0,0,1,29.162,0Z",
    transform: "translate(0 10.058)",
    fill: "#ECEEF0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M34.482,6l-1.469,5.685A72.87,72.87,0,0,0,19.993,6,33.92,33.92,0,0,0,8.8,4.715a10.034,10.034,0,0,0,.542,4.034,10.23,10.23,0,0,0,1.921,2.935l2.256-2.935,6.47,2.935-8.255,7.7a55.147,55.147,0,0,1-7.15-8.413A45.838,45.838,0,0,1,0,1.6,50.553,50.553,0,0,1,17.361.288C25.982,1.388,34.482,6,34.482,6Z",
    transform: "translate(12.839 20.387)",
    fill: "#ECEEF0"
  }))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logo.1e7f3d78.svg";
export { ForwardRef as ReactComponent };